import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=61ad56be&"
import script from "./AdminEdit.vue?vue&type=script&lang=js&"
export * from "./AdminEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports